import * as fs from 'fs';
import { Logger } from './logger';

/**
 * the file replacement function.
 * @param sourceContentFilePath the source file path.
 * @param writeToFilePath the write to file path.
 */
export async function fileReplacement(sourceContentFilePath: string, writeToFilePath: string) {
    const prefix = 'fileReplacement';
    try {
        const data = await fs.promises.readFile(sourceContentFilePath, 'utf-8');
        await fs.promises.writeFile(writeToFilePath, data, 'utf-8');
        Logger.log(`File "${sourceContentFilePath}" replaced with "${writeToFilePath}".`, prefix);
    } catch (error) {
        Logger.error(`Error: ${error.message}`);
    }
}
